<template>
  <div class="modal modal-color" @click.self="closePopup">
    <div class="modal-dialog">
      <div class="modal-title flex-center text-center mr-3 ml-3" v-if="!openPopup">{{ $lang.messages.add_device.title }}</div>
      <div class="modal-title" v-if="openPopup === 'desktop'">
        <img src="../assets/img/image-desktop.svg" alt="icon desktop" class="add-device-title-icon">
        {{ $lang.messages.add_device.add_desktop }}
      </div>
      <div class="modal-title" v-if="openPopup === 'mobileContent'">
        <img src="../assets/img/image-mobile.svg" alt="icon desktop" class="add-device-title-icon">
        {{ $lang.messages.add_device.add_mobile }}
      </div>
      <span class="modal-close" @click="closePopup" v-if="!hideClose">
        <svg width="17" height="17" fill="white"><use xlink:href="#icon-close-small"></use></svg>
      </span>
      <div class="modal-content" :class="{'-wide': openPopup}">
        <div class="row" v-if="!openPopup">
          <div class="col-6">
            <div class="text-center add-device-block">
              <div class="add-device-image">
                <img src="../assets/img/image-desktop.svg" alt="image desktop">
              </div>
              <div class="mb-1 locked-title text-bold">{{ $lang.messages.add_device.desktop }}</div>
              <div>
                <button class="btn btn-main" @click="openPopup = 'desktop'">{{ $lang.messages.add }}</button>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="text-center add-device-block">
              <div class="add-device-image">
                <img src="../assets/img/image-mobile.svg" alt="image mobile">
              </div>
              <div class="mb-1 locked-title text-bold">{{ $lang.messages.add_device.mobile }}</div>
              <div>
                <button class="btn btn-main" @click="openPopup = 'mobile'">{{ $lang.messages.add }}</button>
              </div>
            </div>
          </div>
        </div>
        <p v-if="openPopup === 'desktop' || openPopup === 'mobileContent'" class="add-device-text">{{ $lang.messages.add_device.several_options }}</p>
        <div v-if="openPopup === 'desktop'">
          <div class="add-device-block -list flex-center">
            <div class="add-device-block-icon flex-center"><i class="icon-download"></i></div>
            <div class="add-device-block-content">
              <div class="add-device-block-title">{{ $lang.messages.add_device.go_chrome_store }}</div>
              <div class="add-device-block-text">{{ $lang.messages.add_device.several_options }}</div>
            </div>
            <div class="add-device-block-btn">
              <a :href="extLink"
                 target="_blank" class="btn btn-main">{{ $lang.messages.add_device.get_extension }}</a>
            </div>
          </div>
          <div class="add-device-block p-0 flex-center">
            <img src="../assets/img/chrome-store-screen.png" alt="chrome store">
          </div>
        </div>
        <div v-if="openPopup === 'mobileContent'">
          <div class="add-device-block -list flex-center">
            <div class="add-device-block-icon flex-center"><i class="icon-google-play"></i></div>
            <div class="add-device-block-content">
              <div class="add-device-block-title">{{ $lang.messages.add_device.go_google_play }}</div>
              <div class="add-device-block-text">{{ $lang.messages.add_device.go_google_play_description }}</div>
            </div>
            <div class="add-device-block-btn">
              <a :href="appLink" target="_blank" class="btn btn-main">{{ $lang.messages.add_device.get_app }}</a>
            </div>
          </div>
          <div class="add-device-block -list flex-center">
            <div class="add-device-block-icon flex-center"><i class="icon-file-copy"></i></div>
            <div class="add-device-block-content">
              <div class="add-device-block-title">{{ $lang.messages.add_device.copy_link }}</div>
              <div class="add-device-block-text">{{ $lang.messages.add_device.copy_link_description }}</div>
            </div>
            <div class="add-device-block-btn">
              <button class="btn btn-outline" @click="copyLink(appLink)">{{ $lang.messages.add_device.copy }}</button>
            </div>
          </div>
          <div class="add-device-block -list flex-center">
            <div class="add-device-block-icon flex-center"><i class="icon-insert-link"></i></div>
            <div class="add-device-block-content">
              <div class="add-device-block-title">{{ $lang.messages.add_device.sent_link }}</div>
              <div class="add-device-block-text">{{ $lang.messages.add_device.sent_link_description }}</div>
            </div>
            <div class="add-device-block-btn">
              <button class="btn btn-outline">{{ $lang.messages.add_device.sent_link_to }}</button>
            </div>
          </div>
        </div>
        <div v-if="openPopup === 'mobile'">
          <div class="row mt-3">
            <div class="col-sm-7">
              <div class="text-huge text-bold text-white mt-2 mb-1">{{ $lang.messages.add_device.mobile_title }}</div>
              <div class="text-lg text-white mb-2">{{ $lang.messages.add_device.mobile_text }}</div>
              <div>
                <button class="btn btn-main -shadow" @click="openPopup = 'mobileContent'">{{ $lang.messages.add_device.mobile_btn }}</button>
              </div>
            </div>
            <div class="col-sm-5">
              <img src="../assets/img/add-device-mobile.png" alt="add mobile">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { extensionLink, applicationLink } from '@/helpers/configs'

export default {
  name: 'AddDevice',
  props: ['defaultOpenScreen', 'hideClose'],
  data: function() {
    return {
      openPopup: this.defaultOpenScreen || null,
      extLink: extensionLink,
      appLink: applicationLink
    }
  },
  methods: {
    closePopup(){
      this.$emit('closepopup')
      this.openPopup = null
    },
    copyLink (content) {
      const el = document.createElement('div')
      el.innerHTML = content
      document.body.appendChild(el)
      const range = new Range()
      range.selectNode(el)
      const select = window.getSelection()
      select.removeAllRanges()
      select.addRange(range)
      document.execCommand('copy')
      el.remove()
    }
  }
}

</script>

<style lang="scss">
@import "../assets/styles/helpers";

.add-device {
  &-block {
    background-color: #F5F7FB;
    border-radius: 16px;
    padding: 15px;

    &-content {
      padding-right: 20px;
      width: 65%;

      @include responsive-below($sm){
        padding-right: 0;
        width: 100%;
        margin-bottom: 10px;
      }
    }

    &-btn {
      width: 35%;

      @include responsive-below($sm){
        width: 100%;
        text-align: center;
      }

      .btn {
        width: 100%;
      }
    }

    &.-list {
      position: relative;
      padding: 24px 24px 24px 70px;

      @include responsive-below($sm){
        flex-direction: column;
        padding-left: 50px;
      }
    }

    &-icon {
      width: 76px;
      height: 76px;
      background: #FFFFFF;
      border-radius: 50%;
      box-shadow: 0 2px 3.61905px rgba(0, 0, 0, 0.25);
      position: absolute;
      top: 50%;
      left: 0;
      transform: translate(-50%, -50%);
      font-size: 40px;
      color: #5A4A99;

      .icon-insert-link {
        font-size: 70px;
      }
    }

    &-title {
      font-size: 24px;
      font-weight: 700;
      margin-bottom: 6px;

      @include responsive-below($sm){
        font-size: 20px;
      }
    }

    & + & {
      margin-top: 8px;
    }
  }
  &-image {
    margin-top: -30px;
    margin-bottom: 20px;

    @include responsive-below($sm){
      margin-bottom: 10px;

      img {
        max-height: 100px;
      }
    }
  }

  &-title-icon {
    max-height: 38px;
    margin-right: 20px;
  }

  &-text {
    font-size: 20px;
    margin-bottom: 32px;
    color: #fff;

    @include responsive-below($sm){
      font-size: 18px;
      margin-bottom: 16px;
    }
  }
}

</style>
